import React, { useEffect, useState } from 'react';
import watermarkService from 'src/shared/services/watermark.service';
import userService from 'src/shared/services/user.service';
import './styles.scss';

interface WatermarkProps {
  text?: string;
}

const Watermark: React.FC<WatermarkProps> = ({ text }) => {
  const [username, setUsername] = useState<string>('');

  useEffect(() => {
    const getUserText = (): string => {
      if (text) return text;
      
      const userInfo = userService.userInfo;
      if (userInfo?.username) return userInfo.username;
      if (userInfo?.name) return userInfo.name;
      
      if (userService.isLoggedIn()) {
        return 'User';
      }
      
      return '';
    };

    const detectedUsername = getUserText();
    setUsername(detectedUsername);
  }, [text]);

  useEffect(() => {
    if (!username || !userService.isLoggedIn()) {
      return;
    }

    watermarkService.initialize(username);
    
    const startTimer = setTimeout(() => {
      watermarkService.start();
    }, 500);

    return () => {
      clearTimeout(startTimer);
      watermarkService.stop();
    };
  }, [username]);

  return null;
};

// Watermark controller component - renders nothing, manages watermark service
// Detects logged-in username and initializes multi-layer watermark protection
// Starts after 500ms delay to avoid blocking initial render
// Cleans up on unmount to prevent memory leaks
export default Watermark;

